export const MB = 1024 * 1024;

export const SINGLE_UPLOAD_LIMIT = 20 * MB;
export const CHUNK_SIZE = 5 * MB;

export function shouldUseMultipart(file: File) {
  return file.size > SINGLE_UPLOAD_LIMIT;
}

export function createChunks(file: File) {
  const chunks: Blob[] = [];
  let start = 0;

  while (start <= file.size) {
    chunks.push(file.slice(start, start + CHUNK_SIZE));
    start += CHUNK_SIZE;
  }
  return chunks;
}

export function formatFileSize(size?: number) {
  if (!size) return '-';

  if (size < 1024) return `${size} B`;

  const kb = size / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;

  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(1)} MB`;

  const gb = mb / 1024;
  return `${gb.toFixed(1)} GB`;
}

export function getObsKeyFromSignedUrl(url: string) {
  const urlWithoutQuery = url.split('?')[0];
  const marker = 'com/';
  const index = urlWithoutQuery.lastIndexOf(marker);

  if (index === -1) {
    return urlWithoutQuery;
  }

  return urlWithoutQuery.substring(index + marker.length);
}

export function convertToMp4(obsKey: string) {
  if (!obsKey || !obsKey.includes('.')) {
    return obsKey;
  }

  const parts = obsKey.split('.');
  parts.pop();

  return parts.join('.') + '.mp4';
}